import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input } from '@angular/core';

@Component({
    selector: 'external-calendly',
    standalone: true,
    imports: [],
    templateUrl: './calendly.component.html',
    styleUrl: './calendly.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CalendlyComponent {
    _url: string;
    @Input()
    set url(url: string) {
        this._url = url;
        this._detector.markForCheck();
        queueMicrotask(() => {
            if (document.body.querySelector('[src="https://assets.calendly.com/assets/external/widget.js"]') != null)
                return;
            var scriptElement = document.createElement('script');
            scriptElement.src = "https://assets.calendly.com/assets/external/widget.js";
            scriptElement.type = "text/javascript";
            scriptElement.async = true;
            this._elm.nativeElement.append(scriptElement);
        })
    }

    constructor(private _elm: ElementRef<HTMLElement>, private _detector: ChangeDetectorRef) {}

}
